
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/[others]",
      function () {
        return require("private-next-pages/[region]/[language]/[others]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/[others]"])
      });
    }
  